import NewCampusModalComponent from './new-campus-modal-component'
import NewCampusModalService from './new-campus-modal-service'

/***
 * The modal that pops up allowing you to create a new campus.
 */
const newCampusModal = angular
    .module('FacilityData.ClientEdit.NewCampusModal', [])
    .component('newCampusModal', NewCampusModalComponent)
    .service('NewCampusModalService', NewCampusModalService)
    .name;

export default newCampusModal;


// WEBPACK FOOTER //
// ./app/components/client-edit/new-campus-modal/new-campus-modal.js